// @flow

import React, { Component } from 'react';
import {Toolbar, ToolbarGroup} from 'material-ui/Toolbar';
import localforage from 'localforage';

import {MapButton} from './MapButtons.jsx';
import CultiToolbar from './Toolbar.jsx';
import Medidas from './Medidas.jsx';
import App from './App.jsx';
import Launcher from './Launcher.jsx';

import {no_rclick, takeDir} from './utils.js';
import {CLASSIC_WIDTH, SIDEBAR_WIDTH} from './consts.js';

import type {T_ErrOk, T_Next} from './types.js';

import './css/AppBar.css';


type T_AppBarProps = {
  show_tree        : boolean,
  four_maps        : boolean,
  fix_zoom         : boolean,
  hide_extras      : boolean,
  width            : number,
  app              : App,
  window_drag      : boolean,
  launcher         : Launcher,
  num_decimals     : number,
  dev_mode         : boolean,
  agrosat_user     : boolean,
  closing_four_maps: boolean,
  use_pixel_tool   : boolean,
  configuring_doc  : boolean,
  cond             : boolean
};


type T_AppBarState = {
  cultis    : Array<string>,
  escala_for: ?string
};



export default class AppBar extends Component<T_AppBarProps, T_AppBarState> {
  logout         : () => void;
  close_four_maps: () => void;
  
  
  
  constructor(props: T_AppBarProps) {
    super(props);
    
    this.state = {
      cultis    : [],
      escala_for: null,
    };
    
    this.logout          = this.logout.bind(this);
    this.close_four_maps = this.close_four_maps.bind(this);
    
    props.app.bar = this;
  }
  
  
  
  componentDidUpdate(prevProps: T_AppBarProps, prevState: T_AppBarState) {
    if (! prevProps.cond && this.props.cond) {
      const {app} = this.props;
      
      if (app.medidas != null && ! app.medidas.j_area) {
        app.medidas.setup_draw();
      }
    }
  }
  
  
  
  logout(): void {
    this.props.app.map_ui.map.destroy();
    
    localforage.setItem(window.location.href.indexOf('new_login') !== -1 ? 'dummy' : 'full_user', null);
    
    const url  = `https://${this.props.app.props.domain}/remove-session/?session_id=${this.props.app.session()}&plataforma=gdb`;    // EL PARÁMETRO plataforma ES NECESARIO EN remove-session
    
    fetch(url).then(resp => resp.json()).then((response: T_ErrOk) => {
      this.props.launcher.setState({user: null});
    });
  }
  
  
  
  show_tools(): void {
    if (this.props.app.toolbar) {
      this.props.app.toolbar.setState({use_tools: true });
    }
  }
  
  
  
  hide_tools(): void {
    if (this.props.app.toolbar) {
      this.props.app.toolbar.setState({use_tools: false});
    }
  }
  
  
  
  renew_escala(next: T_Next): void {
    const {app} = this.props;
    
    if (app.toolbar != null && ! this.state.escala_for) {
      const {culti}  = app.toolbar.state,
            dir      = takeDir(culti),
            img_path = this.props.app.map_ui.map.last_img_path(dir);
      
      if (img_path) {
        this.setState({escala_for: img_path}, () => {
          next(true);
        });
      }
      else {
        next(false);
      }
    }
    else {
      next(false);
    }
  }
  
  
  
  close_four_maps(): void {
    const {app} = this.props;
    
    if (app.dialog_thematic != null) {
      app.dialog_thematic.close();
    }
    else if (this.props.four_maps) {
      app.toggle_four_maps(true);
    }
  }
  
  
  
  render() {
    if (! this.props.cond) {
      return null;
    }
    
    const {app} = this.props,
          left  = SIDEBAR_WIDTH + (this.props.show_tree ? CLASSIC_WIDTH : 0),
          width = this.props.width - left - 130,
          show_toolbar = (! this.props.four_maps) && (! this.props.closing_four_maps) &&
                          this.state.cultis.length > 0 && app.four_maps == null && app.map_ui.map != null;
    
    return (
      <div className='appbar_trans' id='app_bar' style={{left, width}}>
        {(! this.props.four_maps) &&
          <Medidas
            width={this.props.width}
            show_tree={this.props.show_tree}
            num_decimals={this.props.num_decimals}
            hide={true}
            use_pixel_tool={this.props.use_pixel_tool}
            app={app}
          />
        }
        
        <Toolbar onContextMenu={no_rclick} id='AppBar'>
          <ToolbarGroup firstChild={true}>
            {show_toolbar &&
              <CultiToolbar
                cultis={this.state.cultis}
                current_map={this.state.escala_for}
                window_drag={this.props.window_drag}
                show_tree={this.props.show_tree}
                width={this.props.width}
                num_decimals={this.props.num_decimals}
                configuring_doc={this.props.configuring_doc}
                app={app}
              />
            }
            
            {this.props.four_maps &&
              <div style={{marginLeft: 30}}>
                <MapButton
                  label='Un sólo mapa'
                  icon='expand'
                  fun={this.close_four_maps}
                />
              </div>
            }
          </ToolbarGroup>
          
          <ToolbarGroup lastChild={true}>
            <MapButton
              label='Salir'
              icon='sign-out'
              bgcolor='#d9534f'
              color='white'
              fun={this.logout}
            />
          </ToolbarGroup>
        </Toolbar>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/AppBar.jsx